<template>
  <div style="background:#fff">
    <div style=" padding-bottom: 100px; padding-top: 20px">
      <!-- 确认单的生成pdf/图片，确认 -->
      <div class="drawer-voucher-footer-button">
        <van-button @click="shotPic"
                    type="primary"
                    block>生成图片</van-button>
        <!-- <el-button @click="copyConfirmation"
                   size="mini">复制确认信息</el-button> -->
      </div>
      <!-- 表单 -->
      <div>
        <div id="booking-confirm-png">
          <!-- 确认单的头部 -->
          <div class="v-header">
            <span v-html="voucherHeader"></span>
            <div v-show="voucherData"
                 id="operator-info-area">
              {{ operator.key }}:{{ operator.value }}
            </div>
            <div v-show="voucherData"
                 id="operator-info-area-triangle"></div>
          </div>
          <!-- 确认单的具体信息（表格） -->
          <div v-if="voucherData == null"
               class="no-data-voucher">
            订单未入库，请处理后查看
          </div>
          <div v-else>
            <el-table :show-header="status"
                      :data="voucherData"
                      style="width: 95%; margin: 0 auto;font-size: 8px"
                      :cell-style="voucherStyle">
              <el-table-column prop="key"
                               width="180%"></el-table-column>
              <el-table-column prop="value"></el-table-column>
            </el-table>
          </div>
          <!-- 确认单Footer的注意事项  -->
          <div style="padding-bottom: 10px"
               v-show="voucherData">
            <div class="footer-title">行前须知</div>
            <div class="voucher-footer">
              <!-- 须知 -->
              <span v-html="voucherFooter"></span>
              <!-- 退改 -->
              <div class="attentionArea"
                   v-show="this.refundInfo !=null">
                <p class="ftw900">退改说明：</p>
                <div class="choice_show_area">{{refundInfo}}</div>
              </div>
              <!-- 定位 -->
              <div v-if="this.poi_info"
                   style="width:20%">
                <el-divider></el-divider>
                <vue-qr :margin="5"
                        colorDark="#0f6ea3"
                        colorLight="#FFF"
                        :logoSrc="qrImageUrl"
                        :text="qrCode"
                        :size="150"></vue-qr>
                <div>
                  <div style="text-align:center">扫码查看定位</div>
                </div>
              </div>
              <div v-else></div>
              <!--  -->
            </div>
          </div>
        </div>
        <div style="padding-bottom: 65px"></div>
      </div>

    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import { Button } from 'vant'
// import html2canvas from 'html2canvas'
import domtoimage from 'dom-to-image'

export default {
  name: 'm_booking_voucher',
  components: {
    vueQr,
    'van-button': Button,
  },
  data() {
    return {
      booking_no: '',
      voucherHeader: '',
      voucherFooter: '',
      refundInfo: '',
      voucherData: [],
      operator: '',
      status: false,
      poi_info: null,
      qrImageUrl: '',
      qrCode: '',
    }
  },
  created() {
    this.$http
      .get(`/booking/booking_voucher?id=${this.$route.query.booking_no}`)
      .then((res) => {
        // console.log(res)
        const {
          data,
          errno,
          errmsg,
          header_introduce,
          operator,
          footer_introduce,
          refund_info,
          poi_info,
          re_mark,
        } = res.data
        if (errno == '0') {
          this.voucherHeader = header_introduce
          this.voucherData = data
          this.operator = operator
          this.voucherFooter = footer_introduce
          this.refundInfo = refund_info
          this.poi_info = poi_info
          this.re_mark = re_mark
          if (poi_info) {
            // 定位链接 http://192.168.50.243:8081/#/pagesTraver/tools/showBookingLocation?latitude=18.6272340000000&longitude=110.2174960000000&scale=18
            this.qrCode = `http://starsurfer.club/#/pagesTraver/tools/showBookingLocation?latitude=${poi_info.lat}&longitude=${poi_info.lng}&scale=18`
          }
          this.getConfirmInfor(this.$route.query.booking_no)
        } else if (errno == '4102') {
          this.$notify.error({
            title: '飞猪授权已过期',
            duration: 0,
            dangerouslyUseHTMLString: true,
            message: `<strong>点击获取授权：<a href="https://oauth.taobao.com/authorize?response_type=code&client_id=29468970&redirect_uri=${this.current_ip}booking/auth&view=web
" style="color: blue；text-decoration:underline">👉【点此授权】</a></strong>`,
          })
        } else {
          this.$message.warning(errmsg)
        }
      })
  },
  mounted() {},
  methods: {
    shotPic() {
      // domtoimage主要的方法有：
      // domtoimage.toPng(...);将节点转化为png格式的图片
      // domtoimage.toJpeg(...);将节点转化为jpg格式的图片
      // domtoimage.toSvg(...);将节点转化为svg格式的图片，生成的图片的格式都是base64格式
      // domtoimage.toBlob(...);将节点转化为二进制格式，这个可以直接将图片下载
      // domtoimage.toPixelData(...);获取原始像素值，以Uint8Array 数组的形式返回，每4个数组元素表示一个像素点，即rgba值。这个方法也是挺实用的，可以用于WebGL中编写着色器颜色。
      //
      // domtoimage主要的属性有：
      // filter ： 过滤器节点中默写不需要的节点；
      // bgcolor ： 图片背景颜色；
      // height, width ： 图片宽高；
      // style ：传入节点的样式，可以是任何有效的样式；
      // quality ： 图片的质量，也就是清晰度；
      // cacheBust ： 将时间戳加入到图片的url中，相当于添加新的图片；
      // imagePlaceholder ： 图片生成失败时，在图片上面的提示，相当于img标签的alt；
      //
      let scale = 2
      let node = document.getElementById('booking-confirm-png')
      console.log(node)
      let options = {
        bgcolor: '#FFF',
        width: node.clientWidth * scale,
        height: node.clientHeight * scale,
        style: {
          transform: 'scale(' + scale + ')',
          transformOrigin: 'top left',
        },
      }
      //
      domtoimage
        .toPng(node, options)
        .then((dataUrl) => {
          let aLink = document.createElement('a')
          aLink.href = dataUrl
          aLink.download = '确认单'
          aLink.click()
        })
        .catch(function (error) {
          console.error('oops, something went wrong!', error)
        })
    },
    //
    //
    // 生成图片
    bookingConfirmImage() {
      let options = {
        allowTaint: false,
        // backgroudColor: null,
        useCORS: true,
        // 下面解决当页面滚动之后生成图片出现白边问题
        // height: document.getElementById('booking_confirm_image').offsetHeight,
        // width: document.getElementById('booking_confirm_image').offsetWidth,
        height: document.getElementById('booking_confirm_image').scrollHeight,
        windowHeight: document.getElementById('booking_confirm_image')
          .scrollHeight,
        // windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        scrollX: 0,
        scrollY: -window.pageYOffset,
        // x: 0,
        // y: 0,
        scale: 4, //
      }
      //
      html2canvas(
        document.getElementById('booking_confirm_image'),
        options
      ).then((canvas) => {
        // document.body.appendChild(canvas)
        let image = canvas.toDataURL('image/png')
        // 下载图片
        this.fileDownload(image)
      })
    },
    fileDownload(downloadUrl) {
      let aLink = document.createElement('a')

      aLink.href = downloadUrl
      aLink.download = '确认单.png'
      // document.body.appendChild(aLink)
      // 触发点击-然后移除
      aLink.click()
    },
    // 确认单 table的样式
    voucherStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return 'background:#F8F8F8;'
      }
    },
    // 获取 确认信息
    getConfirmInfor(booking_no) {
      this.$http.get(`/booking/detail?booking_id=${booking_no}`).then((res) => {
        const { data, errmsg, errno } = res.data
        if (errno == '0') {
          // console.log("进入promise");
          // 订单编号
          let information_id = '订单编号：' + data.about_booking.ota_id + '\n'
          // 出行日期
          let information_date =
            '出行日期：' + data.about_booking.trip_start_date + '\n'
          // 套餐名称
          let information_title =
            '套餐名称：' + data.about_booking.sku_name + '\n'
          // 场次
          let information_time =
            '场次/时间：' +
            this.checkEmpty(data.about_booking.start_time) +
            '\n'

          // 判断 订单信息 是否为空 -》 处理订单信息
          let pick_is_null = this.checkEmpty(data.about_booking.additional_info)
          let addition_info = ''
          if (pick_is_null) {
            let addition_list = []
            pick_is_null.forEach((item, index) => {
              let i = item.name + '：' + item.value + '\n'
              addition_list.push(i)
            })
            addition_info = addition_list.join('')
          } else {
            addition_info = ''
          }

          // 判断人数是否为空 -》 处理人数
          let information_num = this.checkEmpty(data.about_booking.num)
          let num_list = []
          information_num.forEach((item, index) => {
            let i = item.type + '：' + item.num + '\n'
            num_list.push(i)
          })
          let num_info = num_list.join('')

          // 判断附加项是否为空 -》 处理 附加项
          let select_addition_dict = this.checkEmpty(
            data.about_booking.select_addition_dict
          )
          let select_addition_info = ''
          if (select_addition_dict) {
            let select_addition_list = []
            select_addition_dict.forEach((item, index) => {
              let i = item.addition_name + '：' + item.addition_num + '\n'
              select_addition_list.push(i)
            })
            select_addition_info =
              '------附加项------' + '\n' + select_addition_list.join('')
          } else {
            select_addition_info = ''
          }

          // 联系人
          let information_other =
            '联系人姓名：' +
            data.about_contact.name +
            '\n' +
            '联系电话：' +
            data.about_contact.mobile +
            '\n'

          // // 出行人信息：
          // let information_travellers =
          //   "--------" + "\n" + "出行人信息：" + "\n";
          // data.travellers.forEach((i, index) => {
          //   if (i.traveller_name_en == null) {
          //     information_travellers =
          //       information_travellers + i.traveller_name;
          //   } else {
          //     information_travellers =
          //       information_travellers +
          //       i.traveller_name +
          //       i.traveller_name_en;
          //   }

          //   i.credential.forEach((item, index) => {
          //     if (item.credential != null) {
          //       information_travellers =
          //         information_travellers +
          //         "\n" +
          //         item.credential +
          //         ":" +
          //         item.credentialNum +
          //         "\n";
          //     }
          //   });
          // });

          // 汇总
          let information =
            '您好，您的行程已确认' +
            '\n' +
            '到店后报姓名 、电话即可:' +
            '\n' +
            '\n' +
            information_id +
            information_date +
            information_title +
            information_time +
            num_info +
            information_other +
            addition_info +
            select_addition_info

          // 获取确认单信息
          let a = document.getElementsByClassName('voucher-footer')
          let confirm_infor = a[0].innerText
          this.confirmation = information + confirm_infor
          //
        } else if (errno == '4002') {
          this.$notify({
            title: '警告',
            message: '该订单还未入库，请先入库',
            type: 'warning',
          })
        }
      })
    },
    // 检查字符串是否为空
    checkEmpty(str) {
      var res = str
      if (res == '' || res == undefined || res == null) {
        return ''
      } else {
        return res
      }
    },
    //
  },
}
</script>

<style>
.v-header {
  width: 95%;
  margin: auto;
  margin-bottom: 30px;
  padding-top: 10px;
}
.v-header img {
  width: 100%;
}
.voucher-footer {
  width: 90%;
  border: 1px solid #cac9c9;
  padding: 15px;
  margin: 0px auto;
}
.voucher-footer img {
  width: 100%;
}

.footer-title {
  width: 90%;
  border: 1px solid #fab099;
  color: #ffffff;
  background-color: #fab099;
  padding: 3px 15px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  text-align: center;
  font-size: large;
  font-weight: 900;
}

#operator-info-area {
  float: right;
  padding-left: 10px;
  color: whitesmoke;
  width: 150px;
  height: 20px;
  background-color: #ff5421;
}

#operator-info-area-triangle {
  float: right;
  width: 0;
  height: 0;
  border-top: 20px solid #ff5421;
  border-left: 20px solid transparent;
}
</style>